import React from 'react';
import PropTypes from 'prop-types';
import {withResizeDetector} from 'react-resize-detector';
/* Helpers */
import {AUTO_REFRESH_OPTIONS} from '../widget-constants';
/* Components */
import ModalDefault from '../../../common/modal/modal-default';
import Iframe from '../../../common/iframe/iframe';
import WidgetEmpty from '../empty-widget-content/empty-widget-content';
import Loader from '../../../common/loader/Loader';
import WebPageForm from './web-page-form';
/* Styles */
import './web-page.scss';
import WidgetHeader from '../widget-header/WidgetHeader';
import WidgetHeaderButton from '../widget-header/widget-header-button/WidgetHeaderButton';

class WebPageWidget extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isSettingsModalShown: false,
      url: '',
      index: 0,
      isLoadingData: false,
    };
  }

  componentDidMount() {
    this.prepareIframe();
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  toggleSettingsModal = (e) => {
    e.stopPropagation();
    this.setState({
      isSettingsModalShown: !this.state.isSettingsModalShown,
    });
  };

  setIframeState = (isHttp, iframeUrl, config) => {
    this.setState(
      {
        isHttp,
        url: iframeUrl,
      },
      () => {
        if (config.autoRefresh) {
          this.refreshIframe(config.autoRefresh.value);
        }
      }
    );
  };

  prepareIframe = () => {
    const config = (this.props.data && this.props.data.config) || {};
    const iframeUrl = config.urlString || this.state.url;
    fetch(iframeUrl, {method: 'HEAD', mode: 'no-cors'})
      .then(() => {
        this.setIframeState(false, iframeUrl, config);
      })
      .catch(() => {
        this.setIframeState(true, iframeUrl, config);
      });
  };

  handleSave = (data) => {
    const newData = {
      ...this.props.data,
      config: {
        ...data.config,
        urlString: data.url,
      },
      title: data.title,
    };

    this.setState(
      {
        isSettingsModalShown: false,
        url: data.url,
        isLoadingData: true,
      },
      () => {
        this.props.onUpdate(newData);
        if (data.config.autoRefresh) {
          this.refreshIframe(data.config.autoRefresh.value);
        }
      }
    );

    fetch(data.url, {method: 'HEAD', mode: 'no-cors'})
      .then(() => {
        this.setState({
          isHttp: false,
          isLoadingData: false,
        });
      })
      .catch(() => {
        this.setState({
          isHttp: true,
          isLoadingData: false,
        });
      });
  };

  handleRefreshIframe = () => this.refreshIframe();

  refreshIframe = (time) => {
    if (!time) {
      this.setState({index: this.state.index + 1});
      return;
    }
    clearInterval(this.interval);
    this.interval = setInterval(() => {
      this.setState({index: this.state.index + 1});
    }, time);
  };

  openInNewWindow = () => {
    window.open(this.state.url, '_blank');
  };

  renderContent = () => {
    if (!this.state.url) {
      return (
        <WidgetEmpty
          isEditAllowed={this.props.isEditAllowed}
          showSettingsModal={this.toggleSettingsModal}
          //   text="The initial widget configuration is empty"
        />
      );
    }
    if (this.state.isLoadingData) {
      return <Loader />;
    }
    if (this.state.isHttp) {
      return (
        <div className="glu-content__section glu-no-http">
          <span className="g-icon g-icon-info" />

          <div className="glu-h5 text-bold">Something went wrong with this URL </div>
          <div className="glu-h5">The request might have been blocked by your browser</div>
          <br />
          <br />
          <div className="glu-h5">Visit this URL in a separate window:</div>

          <div className="glu-h4 cursor-pointer url-link" onClick={this.openInNewWindow}>
            {this.state.url}
          </div>
        </div>
      );
    }

    return (
      <div
        className="glu-content__section glu-content__iframe
              glu-content__separator glu-content__separator--inner"
      >
        <Iframe source={this.state.url} key={this.state.index} />
      </div>
    );
  };

  render() {
    return (
      <>
        <div className="glu-dashboard-card glu-content">
          <WidgetHeader
            isEditAllowed={this.props.isEditAllowed}
            title={this.props.data.title}
            height={this.props.height}
            width={this.props.width}
            showWidgetInfo={this.props.showWidgetInfo(this.props.data)}
            openConfiguration={this.toggleSettingsModal}
            onRemove={this.props.onRemove(this.props.data)}
            onClone={this.props.onClone(this.props.data)}
          >
            <WidgetHeaderButton
              showButton={this.state.url}
              iconName="exit-from-the-app"
              onClick={this.openInNewWindow}
              hoverTooltip={'Open in a New Tab'}
            />
            <WidgetHeaderButton
              showButton={this.state.url}
              iconName="refresh"
              onClick={this.handleRefreshIframe}
              hoverTooltip={'Refresh'}
            />
          </WidgetHeader>
          <div className="glu-content__body">{this.renderContent()}</div>
        </div>
        {this.state.isSettingsModalShown && (
          <ModalDefault isOpen={this.state.isSettingsModalShown}>
            <div className="glu-modal-content">
              <div className="glu-modal__header">
                <div className="glu-modal__title glu-flex-grow">{this.props.data.title}</div>
                <div className="glu-flex-shrink">
                  <button
                    aria-label="close"
                    type="button"
                    className="g-icon glu-btn-link  g-icon-close"
                    onClick={this.toggleSettingsModal}
                  />
                </div>
              </div>
              <WebPageForm
                initialValues={{
                  ...this.props.data,
                  config: {
                    ...this.props.data.config,
                    autoRefresh: this.props.data.config.autoRefresh || AUTO_REFRESH_OPTIONS[0],
                  },
                  url: this.state.url,
                }}
                onFormSubmit={this.handleSave}
                onCancel={this.toggleSettingsModal}
              />
            </div>
          </ModalDefault>
        )}
      </>
    );
  }
}

WebPageWidget.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  isEditAllowed: PropTypes.bool,
  onRemove: PropTypes.func,
  onUpdate: PropTypes.func,
  showWidgetInfo: PropTypes.func,
  onClone: PropTypes.func,
};

WebPageWidget.defaultProps = {
  isEditAllowed: false,
  onRemove: undefined,
  onUpdate: undefined,
  showWidgetInfo: undefined,
  onClone: undefined,
};

export default withResizeDetector(WebPageWidget);
